export default [
    {
        path: '/players-reports-api',
        name: 'PagePlayersReportsApiList',
        meta: { title: 'playersReportsApi.listTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/players-reports-api'),
    },
    {
        path: '/players-reports-api/create',
        name: 'PagePlayersReportsApiCreate',
        meta: { title: 'playersReportsApi.createFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/players-reports-api/create'),
    },
    {
        path: '/players-reports-api/:id/edit',
        name: 'PagePlayersReportsApiEdit',
        meta: { title: 'playersReportsApi.editFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/players-reports-api/id/edit'),
    }
]
